/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Street } from './Street';
import {
    StreetFromJSON,
    StreetFromJSONTyped,
    StreetToJSON,
    StreetToJSONTyped,
} from './Street';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    additionalInfo: string;
    /**
     * 
     * @type {Street}
     * @memberof Address
     */
    street: Street;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    countryIso2: string;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): value is Address {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('additionalInfo' in value) || value['additionalInfo'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('countryIso2' in value) || value['countryIso2'] === undefined) return false;
    return true;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'additionalInfo': json['additionalInfo'],
        'street': StreetFromJSON(json['street']),
        'zipCode': json['zipCode'],
        'city': json['city'],
        'countryIso2': json['countryIso2'],
    };
}

export function AddressToJSON(json: any): Address {
    return AddressToJSONTyped(json, false);
}

export function AddressToJSONTyped(value?: Address | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'additionalInfo': value['additionalInfo'],
        'street': StreetToJSON(value['street']),
        'zipCode': value['zipCode'],
        'city': value['city'],
        'countryIso2': value['countryIso2'],
    };
}

